import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_FAILURE,
  FETCH_SETTINGS_SUCCESS,
  //
  SAVE_SETTINGS,
  SAVE_SETTINGS_FAILURE,
  SAVE_SETTINGS_SUCCESS,
} from "./constants";

// List
export const fetchSettings = (payload) => ({
  type: FETCH_SETTINGS,
  payload,
});
export const fetchSettingsSuccess = (payload) => ({
  type: FETCH_SETTINGS_SUCCESS,
  payload,
});
export const fetchSettingsFailure = (payload) => ({
  type: FETCH_SETTINGS_FAILURE,
  payload,
});
// ADD
export const saveSettings = (payload) => ({
  type: SAVE_SETTINGS,
  payload,
});
export const saveSettingsSuccess = (payload) => ({
  type: SAVE_SETTINGS_SUCCESS,
  payload,
});
export const saveSettingsFailure = (payload) => ({
  type: SAVE_SETTINGS_FAILURE,
  payload,
});
